<main>
  <mat-horizontal-stepper #stepper role="tablist" [attr.aria-label]="'content.first-time-login-content' | translate" [linear]="true">
    <mat-step #step1 [completed]="false">
      <form [formGroup]="termsAndConditionsFormGroup" (submit)="onAgree(termsAndConditionsFormGroup.value)">
        <ng-template matStepLabel>{{ 'content.terms' | translate }}</ng-template>
        <h1>{{ 'content.accept-terms' | translate }}</h1>
        <p>{{ 'content.you-must-accept-terms' | translate }}</p>
        <div class="terms-of-use" [innerHTML]="'content.terms-of-use-body' | translate"></div>
        <hr/>
        <div class="d-flex align-items-center">
          <div>{{ 'content.do-you-agree-to-terms' | translate }} *</div>
          <input id="accept-tou" class="ms-4 me-2" type="checkbox" formControlName="acceptTou">
          <label class="mb-0" for="accept-tou">{{ 'content.yes' | translate }}</label>
        </div>
        <div class="d-flex justify-content-end inline-gap-5 submit-buttons">
          <button class="tu-button secondary tu-shadow" type="button" (click)="authenticationService.logout()">{{ 'content.cancel' | translate }}</button>
          <button class="tu-button primary tu-shadow" type="submit" [disabled]="!termsAndConditionsFormGroup.controls.acceptTou.value">{{ 'content.next' | translate }}</button>
        </div>
      </form>
    </mat-step>
    <mat-step #step2 [completed]="false">
      <ng-template matStepLabel>{{ 'content.change-password' | translate }}</ng-template>
      <h1>{{ 'content.change-password' | translate }}</h1>
      <div class="d-flex justify-content-end">{{ 'content.all.required-field-explanation' | translate }}</div>
      <div class="mt-3 mb-3">{{ 'content.required-to-choose-new-password' | translate }}</div>
      <app-reset-password mode="normal" [saveEnabled]="termsAndConditionsFormGroup.controls.acceptTou.value" (passwordChanged)="onPasswordChanged($event)"></app-reset-password>
      <div class="d-flex justify-content-end submit-buttons mt-4 inline-gap-3">
        <!-- AODA / WCAG:G80 - This button, which changes context, is not the main button which does so.  It's a second method.  The app-reset-password component is the primary
        way the context changes and is triggered via a submit button. -->
        <button class="tu-button secondary tu-shadow" (click)="logout()">{{ 'content.cancel' | translate }}</button>
        <button class="tu-button primary tu-shadow" [disabled]="!passwordChanged" (click)="stepper.next()">{{ 'content.next' | translate }}</button>
      </div>
    </mat-step>
    <mat-step #step3 [completed]="false">
      <ng-template matStepLabel>{{ 'content.mfa' | translate }}</ng-template>
      <h1 class="mt-4">{{ 'content.mfa' | translate }}</h1>
      <div class="d-flex justify-content-end">{{ 'content.all.required-field-explanation' | translate }}</div>
      <p class="mb-3">{{ 'content.required-to-add-mfa' | translate }}</p>
      <p>{{ 'content.need-to-log-in-again' | translate }}</p>
      <h2>{{ 'content.set-up' | translate }}</h2>
      @if (userName) {
        <app-mfa-user-device-admin [allowAddingMultiple]="false" [getExistingMfaDevices]="false"
          [allowChangingPrimary]="false" [allowRemovingDevice]="false" [userName]="userName"
        (mfaDevicesChanged)="onMfaDevicesChanged($event)"></app-mfa-user-device-admin>
      }
      <div class="mt-3">
        @if (mfaDeviceAdded) {
          <p>{{ 'content.successfully-added-a-multi-factor-device' | translate }}</p>
        }
        <div class="d-flex justify-content-end submit-buttons inline-gap-3 mt-4">
          <!-- Yes, these buttons do the same thing.  They both exist because the user expects them to.  Same with the finish button being disabled if the user is not done yet -->
          <button class="tu-button secondary tu-shadow" (click)="logout()">
            {{ 'content.cancel' | translate }}
          </button>
          <button class="tu-button primary tu-shadow" [disabled]="!firstTimeLoginCompleted" (click)="logout()">
            {{ 'content.finish' | translate }}
          </button>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</main>
